import client from '../core/client';
import { getBodyData } from '../utils';

export default () => getBodyData(client.get('/v1/banks/'));
